import { sliders } from "./sliders";

const heroSlider = document.querySelector('.heroSwiper')
const galleryCarousel = document.querySelector('.galleryCarousel')

sliders(heroSlider, {
    pagination: {
        el: ".swiper-pagination",
        type: "bullets",
        clickable: true,
    },
    effect: "fade",
    crossFade: true,
    navigation: {
        nextEl: ".swiper-custom-button-next",
        prevEl: ".swiper-custom-button-prev",
    },
})

sliders(galleryCarousel,{
    slidesPerView: 1,
    spaceBetween: 0,
    loop: false,
    pagination: {
            el: ".swiper-pagination",
            type: "bullets",
            clickable: false,
          },
    navigation: {
      nextEl: ".swiper-custom-button-next",
      prevEl: ".swiper-custom-button-prev",
    },      
})

// if heroSlider select .heroNav and if heroSlider has 1 or less slides hide .heroNav
if (heroSlider && heroSlider.querySelectorAll('.swiper-slide').length <= 1) {
    const controlsContainer = heroSlider.querySelector('.heroNav');
    if (controlsContainer) controlsContainer.style.display = 'none';
}

const swiperServices = document.querySelectorAll('.swiperServices');
let swiperInstances = []; // store all created swiper instances

function initSwiperService() {
  if (swiperInstances.length) return; // already initialized
  swiperServices.forEach(service => {
    const instance = sliders(service, {
      pagination: {
        el: ".swiper-pagination",
        type: "bullets",
        clickable: false,
      },
      effect: "fade",
      crossFade: true,
    });
    // sliders(...) may return the Swiper instance; store it if available
    if (instance) {
      swiperInstances.push(instance);
    }
  });
}

function getWindowDetails() {
  const width = window.innerWidth;
  const orientation = width > window.innerHeight ? 'landscape' : 'portrait';
  return { width, orientation };
}

function handleResize() {
  const { width, orientation } = getWindowDetails();

  if (width < 1023 || orientation === 'portrait') {
    if (swiperInstances.length === 0) {
      initSwiperService(); // init only if not already initialized
    }
  } else {
    if (swiperInstances.length > 0) {
      // destroy all stored instances and clear the array
      swiperInstances.forEach(inst => {
        if (inst && typeof inst.destroy === 'function') {
          inst.destroy(true, true);
        }
      });
      swiperInstances = [];
    }
  }
}

handleResize(); // Run on initial load

window.addEventListener('resize', debounce(handleResize, 200));

// Your debounce function
function debounce(func, wait) {
  let timeout;
  return function (...args) {
    clearTimeout(timeout);
    timeout = setTimeout(() => func.apply(this, args), wait);
  };
}